import { CountUp } from "countup.js";

// keyfigures
const keyfigures = document.querySelectorAll(".js-countup");

if (keyfigures.length > 0) {
  const keyfiguresOptions = {
    separator: " ",
    duration: 2,
  };
  const keyfiguresDecimalOptions = {
    separator: " ",
    duration: 2,
    decimalPlaces: 1,
    decimal: ",",
  };

  keyfigures.forEach((number) => {
    const value = parseFloat(number.textContent); // Parse la valeur pour éviter les erreurs
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (value % 1 !== 0) {
            // si nombre décimal
            new CountUp(number, value, keyfiguresDecimalOptions).start();
          } else {
            // si nombre entier
            new CountUp(number, value, keyfiguresOptions).start();
          }
          observer.unobserve(number); // Arrête d'observer après le premier déclenchement
        }
      });
    });

    observer.observe(number);
  });
}
